import React from 'react';
import { Link } from 'react-router-dom';

const ProviderOnboardingStartPage: React.FC = () => {
  return (
    <div>
      <h2>Welcome to provider onboarding</h2>
      <p>
        This setup will collect your business profile, verification, services, calendar,
        deposit policy, portfolio, and final review before go-live.
      </p>

      <Link to="/provider/onboarding/profile">Start with business profile</Link>
    </div>
  );
};

export default ProviderOnboardingStartPage;